import { PropsWithChildren } from 'react';

/**
 * ContentFooter component for wrapping the content of the footer.
 */
function ContentFooter({ children }: PropsWithChildren) {
  return (
    <div className="content-footer">
      <div className="max-container">{children}</div>
    </div>
  );
}

export default ContentFooter;
